"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from "@filadd/phi-plus-styled-system/css";
import { Box } from "@filadd/phi-plus-styled-system/jsx";
export const Backdrop = ({ onUnmount }) => (_jsx(Box, { role: "button", onClick: onUnmount, className: css({
        backdropFilter: "blur(2px)",
        background: "black.a5",
        overflow: "hidden",
        transition: "all 0.3s ease",
        zIndex: "banner",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    }) }));
//# sourceMappingURL=Backdrop.js.map